import React, { useState, useEffect } from 'react'

interface TypewriterTextProps {
  text: string
  speed?: number
  delay?: number
  className?: string
  children?: React.ReactNode
}

const TypewriterText: React.FC<TypewriterTextProps> = ({ text, speed = 150, delay = 0, className = '', children }) => {
  const [displayText, setDisplayText] = useState('')
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      let index = 0
      const interval = setInterval(() => {
        if (index < text.length) {
          setDisplayText(text.slice(0, index + 1))
          index += 1
        } else {
          setIsComplete(true)
          clearInterval(interval)
        }
      }, speed)

      return () => clearInterval(interval)
    }, delay)

    return () => clearTimeout(timer)
  }, [text, speed, delay])

  return (
    <span className={className}>
      {displayText}
      {!isComplete && <span className="ml-1 animate-pulse">|</span>}
      {isComplete && children}
    </span>
  )
}

export default TypewriterText
